import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getDetailOrder(params) {
    return this.get('CartAndOrder/Orders/ById', params)
  }
  downloadReport(params) {
    return this.get('Report/Export', params, 'download')
  }

  postCancelOrder(params) {
    return this.post('CartAndOrder/Orders/Cancel', params)
  }
}

const proxy = new Proxy()
export default proxy
